import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlogShellComponent } from '../../blog-shell/blog-shell.component';
import { TranslationSyncService } from '../../../../services/translation-sync.service';
import { BlogEntryBase } from '../../shared/blog-entry-base';

@Component({
  selector: 'app-design-intention',
  standalone: true,
  imports: [BlogShellComponent, CommonModule],
  templateUrl: './design-intention.component.html',
  styleUrls: ['./design-intention.component.css']
})
export class DesignIntentionComponent extends BlogEntryBase {
  constructor(sync: TranslationSyncService) {
    super(sync);
  }
}
